// extracted by mini-css-extract-plugin
export var backgroundColor = "#141821";
export var borderRadius = ".15rem";
export var maxModalWidth = "48em";
export var modalBackgroundColor = "rgba(20,24,33,.75)";
export var threadContainer = "tweet-module--thread-container--2d618";
export var threadContainerInner = "tweet-module--thread-container-inner--194b0";
export var tweetContainer = "tweet-module--tweet-container--8af03";
export var tweetContainerInner = "tweet-module--tweet-container-inner--ab714";
export var twitterThreadTweet = "tweet-module--twitter-thread-tweet--0fb7a";